/**
 * Onglets (bloc onglet_v2) : un lien .onglet_select active le .onglet ciblé par son ancre.
 * Remplace le composant Vue Onglet.
 */
UNYC.register('onglets', () => {
    UNYC.init('[data-onglets]', 'onglets', (root) => {
        const links = UNYC.qsa('a.onglet_select', root);
        const tablist = root.querySelector('.onglet_selects');

        const syncSelected = () => {
            links.forEach((link) => link.setAttribute('aria-selected', link.classList.contains('active') ? 'true' : 'false'));
        };

        if (tablist) tablist.setAttribute('role', 'tablist');

        links.forEach((link) => {
            const panel = link.hash.length > 1 ? root.querySelector(link.hash) : null;

            link.setAttribute('role', 'tab');
            if (panel) {
                link.setAttribute('aria-controls', panel.id);
                panel.setAttribute('role', 'tabpanel');
            }
        });

        syncSelected();

        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                if (link.classList.contains('active')) return;

                links.forEach((other) => other.classList.toggle('active', other === link));

                const current = root.querySelector('.onglet.active');
                if (current) current.classList.remove('active');

                const target = link.hash.length > 1 ? root.querySelector(link.hash) : null;
                if (target) target.classList.add('active');
                syncSelected();
            });
        });
    });
});
